import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../pages/logo.png';
import './Header.css';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <header>
      <div className="nav-container">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Holy See Bright Academy Logo" />
          </Link>
        </div>

        {/* Hamburger Menu for mobile */}
        <button className="nav-toggle" onClick={toggleNav}>
          <span className="hamburger"></span>
        </button>

        <nav className={isNavOpen ? 'nav-open' : ''}>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li className="dropdown">
              <button className="link-button">About</button>
              <div className="dropdown-content">
                <Link to="/about/background">Background</Link>
                <Link to="/about/management">Management</Link>
                <Link to="/about/objectives">Objectives</Link>
              </div>
            </li>
            <li className="dropdown">
              <button className="link-button">Academics</button>
              <div className="dropdown-content">
                <Link to="/academics/departments">Departments</Link>
              </div>
            </li>
            <li className="dropdown">
              <button className="link-button">Admissions</button>
              <div className="dropdown-content">
                <Link to="/admissions/students">Students</Link>
                <Link to="/admissions/staff">Staff</Link>
                <Link to="/admissions/e-verify">E-Verify</Link>
                <Link to="/admissions/faqs">FAQs</Link>
              </div>
            </li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/login">Main Site</Link></li>
            <li className="dropdown">
              <button className="link-button">Create Account</button>
              <div className="dropdown-content">
                <Link to="/signup">Sign Up</Link>
                <Link to="/student-registration">Student Registration</Link>
                <Link to="/staff-registration">Staff Registration</Link>
              </div>
            </li>
            <li className="dropdown">
              <button className="link-button">Login</button>
              <div className="dropdown-content">
                <Link to="/login">Applicant Login</Link>
                <Link to="/login">Student Login</Link>
                <Link to="/login">Alumni Login</Link>
                <Link to="/login">Staff Login</Link>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
